// src/app/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { sanitizeCompanyLogoUrl } from '../functions/companyLogoUrl';

const persistedUser = JSON.parse(localStorage.getItem('userData') || 'null');
const initialState = {
  companyLogoUrl: sanitizeCompanyLogoUrl(persistedUser?.companyLogoUrl ?? null),
  backButtonUrl: null,
  /** True while /main shows a day sub-view (not the stage grid). */
  mainDaySubViewOpen: false,
  /** Incremented when header Back should return to the main grid; MainPage listens and clears the day view. */
  mainGridBackNonce: 0,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCompanyLogoUrl(state, action) {
      state.companyLogoUrl = sanitizeCompanyLogoUrl(action.payload ?? null);
    },
    setBackButtonUrl(state, action) {
      state.backButtonUrl = action.payload;
    },
    setMainDaySubViewOpen(state, action) {
      state.mainDaySubViewOpen = !!action.payload;
    },
    requestBackToMainGrid(state) {
      state.mainGridBackNonce += 1;
    },
  },
});

export const {
  setCompanyLogoUrl,
  setBackButtonUrl,
  setMainDaySubViewOpen,
  requestBackToMainGrid,
} = uiSlice.actions;
export default uiSlice.reducer;
